import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

/**
 * @COMPONENT_NAME TenantMenuHelp
 * @DESCRIPTION 테넌트별 메뉴 도움말 주소를 관리하는 CRUD 화면 컴포넌트
 *
 * @PROPS 없음
 *
 * @CALLBACKS
 * 
 */

function TenantMenuHelp ( props ) {

    return <BasicCrudScreenType id="TenantMenuHelp" table="TenantMenuHelp" view="VwTenantMenuHelp" />;

}

export default TenantMenuHelp;
